import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/users', data)
    .then(response => {
      return response.data
    })
}
function update(data) {
  return axios.patch(`/users/${data.id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/users', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data) {
    return data.id ? update(data) : store(data)
  },
  updateMe(data) {
    return axios.patch(`/users/me`, data)
      .then(response => {
        return response.data
      })
  }
}
